import React from "react";
import Loading from "./common/Loading";
import GraphQLError from "./pages/errors/GraphQLError";

const WaitForQueries =
  ({ queries, topLevel = false }) =>
  (ViewComponent) =>
  (props) => <ResultWrapper {...{ queryResults: queries, topLevel, ViewComponent }} {...props} />;

export default WaitForQueries;
/**
 * This is a component that will accept a GQL query array and ensure all
 * queries are completed with the resulting data from the queries passed to the ViewComponent.
 */

function resultsReducer(accumulator, { data }) {
  Object.keys(data || {}).forEach((query) => {
    accumulator[query] = data[query];
  });

  return accumulator;
}

function ResultWrapper({ queryResults, ViewComponent, topLevel, ...props }) {
  const isLoading = queryResults.some(({ loading }) => Boolean(loading));
  const hasError = queryResults.some(({ error }) => Boolean(error));
  const dataFromQueries = queryResults.reduce(resultsReducer, {});

  if (isLoading) {
    return <Loading />;
  }
  if (hasError) {
    const { error: firstError } = queryResults.find(({ error }) => Boolean(error));

    return <GraphQLError error={firstError} topLevel={topLevel} />;
  }
  return <ViewComponent {...dataFromQueries} {...props} />;
}
